<template>
    <slide-x-left-transition :duration="index < 5 ? 500+(index*100) : 400" :delay="index < 5 ? 200+(index*100) : 200">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px">
            <ion-item>
                <ion-thumbnail slot="start" style="width: 75px; height: 75px; padding: 5px 0 25px 0">
                    <img v-if="image" :src="image" alt="Produkt">
                    <ion-skeleton-text v-else animated></ion-skeleton-text>
                </ion-thumbnail>
                <ion-label mode="md" class="ion-text-wrap">
                    <ion-badge v-if="badge" style="margin-bottom: 5px">{{ badge }}</ion-badge>
                    <h3>{{ name }}</h3>
                    <div v-html="description"></div>
                </ion-label>
            </ion-item>
            <ion-card-content>
                <ion-row>
                    <ion-col class="text-center">
                        <h1 style="margin-top: 2px">{{ priceString }}</h1>
                    </ion-col>
                    <ion-col class="text-right">
                        <ion-button mode="ios" fill="outline" size="small" @click="addToCard($event, index, slug)">Dodaj do koszyka</ion-button>
                    </ion-col>
                </ion-row>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    export default {
        name: 'ItemWiki',
        props: ['index', 'id', 'code', 'type', 'slug', 'price', 'priceString', 'priceString', 'badge', 'name', 'description', 'image'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            addToCard(e, index, slug){
                let payload = {
                    'index' : index,
                    'slug' : slug
                }
                this.$store.dispatch('shopGlass/SHOP_GLASS_CART_PRODUCT_ADD', payload);
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 6px;
    }
</style>